export const shopCountries = [
  { code: "CO", label: "Colombia" },
  { code: "US", label: "Estados Unidos" },
  { code: "MX", label: "Mexico" },
  { code: "ES", label: "Espana" },
  { code: "AR", label: "Argentina" },
  { code: "CL", label: "Chile" },
];

const timezoneCountryFallbacks = {
  "America/Bogota": "CO",
  "America/New_York": "US",
  "America/Detroit": "US",
  "America/Indiana/Indianapolis": "US",
  "America/Kentucky/Louisville": "US",
  "America/Chicago": "US",
  "America/Denver": "US",
  "America/Phoenix": "US",
  "America/Los_Angeles": "US",
  "America/Anchorage": "US",
  "Pacific/Honolulu": "US",
  "America/Mexico_City": "MX",
  "America/Monterrey": "MX",
  "America/Argentina/Buenos_Aires": "AR",
  "America/Santiago": "CL",
  "Europe/Madrid": "ES",
};

export function detectShopCountryFromBrowser() {
  if (typeof navigator === "undefined") return "CO";
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezoneCountryFallbacks[timezone]) return timezoneCountryFallbacks[timezone];
  } catch {
    return "CO";
  }
  return "CO";
}

export function shopCountryLabel(countryIso2 = "CO") {
  return shopCountries.find((country) => country.code === countryIso2)?.label || countryIso2;
}

export function defaultAddress(countryIso2 = "CO") {
  return { recipientName: "", phone: "", countryIso2, city: "", line1: "" };
}

export function toQuoteItem(item) {
  return { productSlug: item.productSlug, variantSlug: item.variantSlug || undefined, quantity: item.quantity };
}

export function cartKey(productSlug, variantSlug) {
  return `${productSlug}::${variantSlug || "default"}`;
}

export function maxQuantity(variant) {
  return Math.max(1, Math.min(Number(variant?.maxPerOrder || 9), 9));
}

export function priceForVariant(prices = [], variant, countryIso2 = "CO") {
  const preferredCurrency = countryIso2 === "CO" ? "COP" : "USD";
  const variantId = variant?.id || null;
  return prices
    .filter((price) => price.currencyCode === preferredCurrency)
    .filter((price) => price.variantId === variantId || price.variantId === null)
    .sort((left, right) => {
      if (left.variantId === variantId && right.variantId !== variantId) return -1;
      if (right.variantId === variantId && left.variantId !== variantId) return 1;
      if (left.countryIso2 === countryIso2 && right.countryIso2 !== countryIso2) return -1;
      if (right.countryIso2 === countryIso2 && left.countryIso2 !== countryIso2) return 1;
      return left.sortOrder - right.sortOrder;
    })[0] || null;
}

export function typeLabel(type) {
  return {
    digital_code: "Codigo digital",
    physical: "Producto fisico",
    entitlement: "Beneficio",
    service: "Servicio",
  }[type] || "Producto";
}

export function productSummary(product) {
  return product?.subtitle || product?.description || "Producto oficial Nitro listo para agregar al carrito.";
}

export function itemRequiresShipping(product, variant = null) {
  if (variant?.requiresShipping !== null && variant?.requiresShipping !== undefined) return Boolean(variant.requiresShipping);
  return Boolean(product?.requiresShipping) || product?.type === "physical";
}

export function primaryImage(product, variant = null) {
  return variant?.media?.[0]?.imageUrl || product?.media?.[0]?.imageUrl || "";
}

export function money(value, countryIso2 = "CO", currencyCode = "") {
  const currency = currencyCode || (countryIso2 === "CO" ? "COP" : "USD");
  return new Intl.NumberFormat(countryIso2 === "CO" ? "es-CO" : "en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: currency === "COP" ? 0 : 2,
  }).format(Number(value || 0));
}
